export default __webpack_public_path__ + "static/media/add-list-icon.661af5f5.svg";